import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

export interface AnnouncementIndividualTypes {
  GET_ANNOUNCEMENT_INDIVIDUAL_REQUEST: 'GET_ANNOUNCEMENT_INDIVIDUAL_REQUEST';
  GET_ANNOUNCEMENT_INDIVIDUAL_SUCCESS: 'GET_ANNOUNCEMENT_INDIVIDUAL_SUCCESS';
  GET_ANNOUNCEMENT_INDIVIDUAL_FAILURE: 'GET_ANNOUNCEMENT_INDIVIDUAL_FAILURE';
}

export interface AnnouncementIndividualActions {
  getAnnouncementIndividualRequest: (announcementId: string) => any;
  getAnnouncementIndividualSuccess: (announcement: any) => any;
  getAnnouncementIndividualFailure: (error: any) => any;
}

const { Types, Creators } = createActions<
  AnnouncementIndividualTypes,
  AnnouncementIndividualActions
>({
  getAnnouncementIndividualRequest: ['announcementId'],
  getAnnouncementIndividualSuccess: ['announcement'],
  getAnnouncementIndividualFailure: ['error'],
});

export const AnnouncementIndividualTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export interface AnnouncementIndividualState {
  fetching: boolean;
  success: boolean;
  error: boolean;
  announcement: any;
}

export const INITIAL_STATE: AnnouncementIndividualState = {
  fetching: false,
  success: false,
  error: false,
  announcement: null,
};

/* ------------- Reducers ------------- */

export const request = (state: any) => {
  // Handle both seamless-immutable and plain objects
  if (state && typeof state.merge === 'function') {
    return state.merge({
      fetching: true,
      success: false,
      error: false,
    });
  } else {
    return {
      ...state,
      fetching: true,
      success: false,
      error: false,
    };
  }
};

export const success = (state: any, { announcement }: { announcement: any }) => {
  // Handle both seamless-immutable and plain objects
  if (state && typeof state.merge === 'function') {
    return state.merge({
      fetching: false,
      success: true,
      error: false,
      announcement,
    });
  } else {
    return {
      ...state,
      fetching: false,
      success: true,
      error: false,
      announcement,
    };
  }
};

export const failure = (state: any, { error }: { error: any }) => {
  // Handle both seamless-immutable and plain objects
  if (state && typeof state.merge === 'function') {
    return state.merge({
      fetching: false,
      success: false,
      error: true,
      announcement: null,
    });
  } else {
    return {
      ...state,
      fetching: false,
      success: false,
      error: true,
      announcement: null,
    };
  }
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ANNOUNCEMENT_INDIVIDUAL_REQUEST]: request,
  [Types.GET_ANNOUNCEMENT_INDIVIDUAL_SUCCESS]: success,
  [Types.GET_ANNOUNCEMENT_INDIVIDUAL_FAILURE]: failure,
});

/* ------------- Selectors ------------- */

export const AnnouncementIndividualSelectors = {
  getAnnouncementIndividualFetching: (state: any) => state.announcementIndividual?.fetching || false,
  getAnnouncementIndividualSuccess: (state: any) => state.announcementIndividual?.success || false,
  getAnnouncementIndividualError: (state: any) => state.announcementIndividual?.error || false,
  getAnnouncementIndividual: (state: any) => state.announcementIndividual?.announcement || null,
};
